import { Card, Grid } from "@mui/material";
import Roller, { IRoller } from "../Components/Cards/Roller";
import RollersDB from "../Assets/RollersDB.json";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";

const RollersPage: React.FC = () => {
  const rollers = RollersDB as object[]; 
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <HeaderCard />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 9, md: 12, lg: 8 }}
      >
        {
        rollers.map((item) => {
          const roller = item as IRoller;
          return (
            <Grid key={roller.id} item xs={2} sm={3} md={3} lg={2}>
              <Card sx={{ maxWidth: 480 }} elevation={12}>
                <Roller {...roller}></Roller>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default RollersPage;